import { OutboundContainerDetailPage } from "@/features/outbound-container/pages/OutboundContainerDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/outbound-container/$id/detail")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["container.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: OutboundContainerDetailPage,
});
